import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import storyData from '../../assets/stories/Story-2.json';
import './Story2.css';

const Story2: React.FC = () => {
  const [showText, setShowText] = useState(false);
  const history = useHistory();

  const handleNext = () => {
    if (!showText) {
      setShowText(true);
    } else {
      history.push('/tictactoe');
    }
  };

  return (
    <div className={`story2-container ${showText ? 'portrait' : 'house'}`}>
      <button className="close-button" onClick={() => history.push('/')}>X</button>
      {showText && (
        <div className="parchment">
          <h2>{storyData.title}</h2>
          <p>{storyData.text}</p>
        </div>
      )}
      <button className="next-button" onClick={handleNext}>
        {!showText ? 'Next' : 'Accept Challenge'}
      </button>
    </div>
  );
};

export default Story2;